import { render, staticRenderFns } from "./DraftTable.vue?vue&type=template&id=61c9ab0c"
import script from "./DraftTable.vue?vue&type=script&lang=ts"
export * from "./DraftTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports